import type { InboxItem } from "../shared/updates";
let pending: { item: InboxItem; expires: number } | undefined;
export function rememberReviewReceipt(item: InboxItem) {
  pending = { item, expires: Date.now() + 60000 };
}
export function pendingReviewReceipt(board: string, thread: string) {
  return pending &&
    pending.expires > Date.now() &&
    pending.item.board_id === board &&
    pending.item.thread_id === thread
    ? pending.item
    : undefined;
}
export function forgetReviewReceipt(id: string) {
  if (pending?.item.id === id) pending = undefined;
}
